/*
 * @Description: '关于我们'页面所有路由
*/

export default [
    {
        path: 'kydh',
        component: resolve => require(['@/views/kydh/index'], resolve),
        name: 'kydh',
        meta: {
            nav: '科研工具'
        }
    },
  {
    path: 'kydh_detail',
    component: resolve => require(['@/views/kydh/detail'], resolve),
    name: 'kydh_detail',
    meta: {
      nav: '科研工具详情'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/kydh.js